import React from "react";
import { AuthUserContext } from "../Session";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { hasAnyPermission } from "../../functions/authorization";

/**
 * BreadcrumbLink
 *
 * Renders a clickable Link if the authenticated user has at least one
 * of the required permissions; otherwise renders plain Typography text.
 *
 * Props:
 *  - to          {string}   Route to link to
 *  - label       {string}   Text to display
 *  - permissions {string[]} List of permission names that grant access to the link
 */
const BreadcrumbLink = ({ to, label, permissions = [] }) => {
  return (
    <AuthUserContext.Consumer>
      {(authUser) => {
        const hasAccess =
          permissions.length === 0 || hasAnyPermission(authUser, permissions);

        if (hasAccess) {
          return (
            <Link to={to} color="inherit">
              {label}
            </Link>
          );
        }

        return <Typography color="textPrimary">{label}</Typography>;
      }}
    </AuthUserContext.Consumer>
  );
};

export default BreadcrumbLink;